<template>
  <div class="verification">
    <loading-primary v-if="isPageLoading"/>
    <div class="verification__wrapper" v-if="!invalidPage">
      <svg xmlns="http://www.w3.org/2000/svg" width="181" height="140" viewBox="0 0 181 140">
          <g fill="none" fill-rule="evenodd">
              <g transform="translate(41)">
                  <circle cx="70" cy="70" r="70" fill="#E5E5EA"/>
                  <circle cx="70" cy="70" r="58.333" fill="#D5D5DA"/>
                  <g fill="#FFF" fill-rule="nonzero">
                      <path d="M104.357 104.053l12.678-47.313-33.352 13.665 10.007 20.21-.535.31L80.424 71.75l-12.236 5.01-8.09-10.456-20.613 10.239-.31-.536 18.751-12.504-22.04-28.462-12.667 47.27a4 4 0 0 0 2.829 4.899l73.41 19.67a4 4 0 0 0 4.9-2.828z"/>
                      <path d="M116.062 53.355L38.368 32.537l29.095 37.57a4 4 0 0 0 4.68 1.253l43.92-18.005z"/>
                  </g>
              </g>
              <g fill="#5AC8FA" transform="translate(0 49)">
                  <rect width="35" height="10" rx="5"/>
                  <rect width="21" height="10" x="8" y="16" rx="5"/>
                  <rect width="23" height="10" x="12" y="32" rx="5"/>
              </g>
          </g>
      </svg>
      <h2 class="title small-title">Registration Success, please activate your account!</h2>
      <h6 class="description subhead">Please confirm your email address. a confirmation email was sent to your email address. click “send again” button below if you did not received the email.</h6>
      <button :disabled="isDisabled" @click.stop="resend" class="btn-large btn-block primary">
        <div v-if="isButtonLoading" class="wrapper_loading_button">
          <span class="subhead">Send again</span>
          <loading-secondary :size="`button`" />
        </div>
        <span class="subhead color-white" v-else>Send again</span>
      </button>
    </div>
    <div class="verification__wrapper" v-if="expiredTokenResetPassword">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="140" height="140" viewBox="0 0 140 140">
        <defs>
            <path id="a" d="M7.292 24.806h5.833c.875 0 1.458-.437 1.458-1.312v-.145c0-8.31 7.146-15.162 15.604-14.579 7.73.583 13.563 7.29 13.563 15.162v-.438c0 .875.583 1.312 1.458 1.312h5.834c.875 0 1.458-.437 1.458-1.312v-.145C52.5 10.082 41.417-.561 28 .023 15.604.606 6.125 11.103 5.833 23.494c.146.73.73 1.312 1.459 1.312zm-1.459-1.312v.584-.584zm52.5 12.975c0-3.207-2.625-5.831-5.833-5.831H5.833C2.625 30.638 0 33.262 0 36.469v27.7C0 67.376 2.625 70 5.833 70H52.5c3.208 0 5.833-2.624 5.833-5.831v-27.7zM35.875 59.358c.292.874-.438 1.895-1.458 1.895H23.77c-1.021 0-1.604-.875-1.459-1.895l2.625-8.747c-2.187-1.458-3.5-4.082-3.062-6.998.583-2.77 2.77-4.957 5.688-5.54 4.666-.875 8.75 2.478 8.75 6.852 0 2.332-1.167 4.52-3.063 5.686l2.625 8.747z"/>
        </defs>
        <g fill="none" fill-rule="evenodd">
            <circle cx="70" cy="70" r="70" fill="#E5E5EA"/>
            <circle cx="70" cy="70" r="58.333" fill="#FF3B30" fill-opacity=".6"/>
            <use fill="#FFF" transform="rotate(-15 160.355 -105.497)" xlink:href="#a"/>
        </g>
      </svg>
      <h2 class="title small-title">Oops, Reset password has expired</h2>
      <h6 class="description subhead">it look like your link for reset password has already use.</h6>
    </div>
    <div class="verification__wrapper" v-if="expiredTokenSignup">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="140" height="140" viewBox="0 0 140 140">
        <defs>
            <path id="a" d="M7.292 24.806h5.833c.875 0 1.458-.437 1.458-1.312v-.145c0-8.31 7.146-15.162 15.604-14.579 7.73.583 13.563 7.29 13.563 15.162v-.438c0 .875.583 1.312 1.458 1.312h5.834c.875 0 1.458-.437 1.458-1.312v-.145C52.5 10.082 41.417-.561 28 .023 15.604.606 6.125 11.103 5.833 23.494c.146.73.73 1.312 1.459 1.312zm-1.459-1.312v.584-.584zm52.5 12.975c0-3.207-2.625-5.831-5.833-5.831H5.833C2.625 30.638 0 33.262 0 36.469v27.7C0 67.376 2.625 70 5.833 70H52.5c3.208 0 5.833-2.624 5.833-5.831v-27.7zM35.875 59.358c.292.874-.438 1.895-1.458 1.895H23.77c-1.021 0-1.604-.875-1.459-1.895l2.625-8.747c-2.187-1.458-3.5-4.082-3.062-6.998.583-2.77 2.77-4.957 5.688-5.54 4.666-.875 8.75 2.478 8.75 6.852 0 2.332-1.167 4.52-3.063 5.686l2.625 8.747z"/>
        </defs>
        <g fill="none" fill-rule="evenodd">
            <circle cx="70" cy="70" r="70" fill="#E5E5EA"/>
            <circle cx="70" cy="70" r="58.333" fill="#FF3B30" fill-opacity=".6"/>
            <use fill="#FFF" transform="rotate(-15 160.355 -105.497)" xlink:href="#a"/>
        </g>
      </svg>
      <h2 class="title small-title">Oops, Account Activation Link has expired</h2>
      <h6 class="description subhead">it look like your link for account activation has already use.</h6>
    </div>
  </div>
</template>

<script>
import LoadingPrimary from '@/components/Loading/Primary'
import LoadingSecondary from '@/components/Loading/Secondary'
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-verification',
  components: {
    'loading-primary': LoadingPrimary,
    'loading-secondary': LoadingSecondary
  },
  props: {

  },
  data() {
    return {
      invalidPage: false,
      isDisabled: false,
      isButtonLoading: false,
      isPageLoading: false,
      expiredTokenResetPassword: false,
      expiredTokenSignup: false
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    const { query } = this.$route
    if (query) {
      if (query.state && query.email) {

      } else if (query.identifier) {
        this.invalidPage = true
        this.handleValidateToken(query)
      } else {
        this.invalidPage = true
        this.handleInvalidPage()
      }
    }
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    handleInvalidPage () {
      this.$notify({
        group: 'saved',
        title: 'Invalid Page',
        text: 'Invalid Page, redirecting...',
        type: 'danger'
      });
      setTimeout(() => {
        this.$router.push({name: 'home'})
      }, 2000);
    },
    handleValidateToken (query) {
      (async () => {
        this.isPageLoading = true
        query.target_url = query.target_url ? query.target_url : '/'
        const response = await api.post(apiV2.emailTokenValidation, query)
        if (response.status == 201) {
          await this.$store.dispatch('tokenFromActivation', response.data)
          if (query.identifier === 'change_email_verification'){
            const { status, message } = response.data
            await this.$store.dispatch('checkToken')
            this.isPageLoading = false
            const uri = `${response.data.redirect_to}?status=${status}&message=${message}`
            this.$router.push({ path: uri })
          } else {
            this.isPageLoading = false
            this.$router.push({name: 'home', query: {
              state: 'account_activation',
            }})
          }
        } else if (response.status == 400) {
          this.isPageLoading = false
          const { errors } = response.data
          Object.keys(errors).forEach((element) => {
            this.$notify({
              group: 'saved',
              title: 'Bad Request',
              text: `${errors[element]}`,
              type: 'danger'
            })
          });
          if (Object.keys(errors).includes('token')) {
            this.expiredTokenSignup = true
          }
        }
      })();
    },
    resend () {
      (async () => {
        this.isDisabled = true
        this.isButtonLoading = true
        const { email, state } = this.$route.query
        const body = {
          email: email,
          state: state,
        }

        const response = await api.post(apiV2.resendEmail, body);
        if (response.status == 200) {
          this.$notify({
            group: 'saved',
            title: `${response.data.message}`,
            text: `Email has been sent to “${email}”.`,
            type: 'success'
          })
        } else if (response.status == 400) {
          const message = response.data
          Object.keys(message).forEach((element) => {
            this.$notify({
              group: 'saved',
              title: `${element} error`,
              text: `${message[element]}`,
              type: 'danger'
            })
          });
        }

        this.isDisabled = false
        this.isButtonLoading = false
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>